import { Injectable } from '@angular/core';
import { SANITIZE_HTML_CONFIG } from './constants';

type HTML = string;
declare const sanitizeHtml: any;

@Injectable({
  providedIn: 'root'
})
export class SanitizeService {

  static sanitizeHtml(value: HTML): HTML {
    return sanitizeHtml(value, SANITIZE_HTML_CONFIG);
  }

}